import { useCallback } from 'react';

import { useAtom } from '@xstate/store/react';

import type { AudioPlayerStreamingAction } from '../effects/AudioPlayerStreamingManager';
import type { AudioStreamingState } from '../state/AudioPlayerStreamingStore';
import {
	audioPlayerStreamingStore,
	setAudioPlayerStreamingStore,
} from '../state/AudioPlayerStreamingStore';

export const useAudioPlayerStreamingStore = (): {
	state:
		| {
				state: AudioStreamingState.UNINITIALIZED;
		  }
		| {
				state: AudioStreamingState.LOADING;
		  }
		| {
				state: AudioStreamingState.ERROR;
				error: Error;
		  }
		| {
				state: AudioStreamingState.STREAM_STARTED;
				response: ReadableStream;
		  }
		| {
				state: AudioStreamingState.STREAM_DISPOSED;
		  };
	updateAudioPlayerStreamingStore: (action: AudioPlayerStreamingAction) => void;
} => {
	const state = useAtom(audioPlayerStreamingStore);

	const updateAudioPlayerStreamingStore = useCallback(
		(action: AudioPlayerStreamingAction): void => {
			setAudioPlayerStreamingStore(action);
		},
		[],
	);

	return { state, updateAudioPlayerStreamingStore };
};
